import React from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'

import { RectangleNetworkBackground } from '@root/shared/ui'
import { InfoMessage } from '@root/shared/ui-kit'

import * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

import { FacebookXfbmlEmbed } from './facebook-xfbml-embed'

interface SocialFacebookEmbedProps {
  onLoad: () => void
  resource: KnownSocialPlatformResource.FacebookKnownSocialPlatformResource<'facebook'>
}

const getEmbedWidth = (
  resource: KnownSocialPlatformResource.FacebookKnownSocialPlatformResource<'facebook'>,
) =>
  KnownSocialPlatformResource.matchFacebookMediaType(resource.type, {
    onReel: () => 372,
    onVideo: () => 372,
    onPost: () => 372,
    onPage: () => 372,
  })

export const SocialFacebookEmbed = React.memo(
  function SocialFacebookEmbed({ resource, onLoad }: SocialFacebookEmbedProps) {
    const [hasError, setHasError] = React.useState(false)
    const [attempt, setAttempt] = React.useState(0)

    useMount(() => {
      onLoad()
    })

    const handleRetry = () => {
      setHasError(false)
      setAttempt((prev) => prev + 1)
    }

    return (
      <Root>
        {hasError ? (
          <ErrorRoot>
            <InfoMessage intent={'error'} onRetry={handleRetry} />
          </ErrorRoot>
        ) : (
          <FacebookXfbmlEmbed
            key={attempt}
            href={resource.url}
            xfbmlClass={resource.xfbmlClass}
            width={getEmbedWidth(resource)}
            onError={() => setHasError(true)}
          />
        )}
      </Root>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.resource.url === nextProps.resource.url
  },
)

const Root = styled.div`
  ${RectangleNetworkBackground}

  position: relative;
  width: 372px;
  max-height: var(--viewport-height);
  overflow: auto;
`

const ErrorRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 160px;
`
